import axios from 'axios';
import config from '../constants/config';

const BASE_URL = config.API_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('mowasel_current_user');
      window.location.href = '/user/login';
    }
    return Promise.reject(error);
  }
);

export default api;

export function parseError(error, placeholder = 'Something went wrong') {
  if (error.isAxiosError) {
    return placeholder;
  }

  if (error.message && error.message !== '') {
    return error.message;
  }

  const { msg } = error.errors[0];
  return msg;
}

export function onSuccess(type, response = undefined) {
  return { type, response };
}

export function onFailure(type, error) {
  return { type, error };
}
